import styled from 'styled-components'


export const GroupSearch = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background: #F4F6F9;
  border-radius: 6px;
`
export const GroupSearchInput = styled.input`
  border: none;
  background: transparent;
  padding: 10px 15px;
  height: 46px;
  &:focus {
    outline: none;
  }

`
export const GroupSearchButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`


export const AddGroupMembersContainer = styled.div`
  padding: 0 1.5rem;
`

export const AddGroupMembersLabel = styled.div`
  padding: 0 2rem;
`

export const MembersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 0 2rem;
  max-height: 200px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #002e5c46;
    opacity: 0.2;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.2;
    background: #002e5c46;
  }

`
export const MemberItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  gap: 5px;
`
export const MemberRemove = styled.div`
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -25px;
`
export const MemberCard = styled.div`
  flex: 1;
  background: #F4F6F9;
  color: #002e5c;
  border-radius: 6px;
  height: 46px;
  padding: 1.25rem 1.5rem;
`
export const MemberSwitch = styled.div`
  margin-right: -12px
`;

export const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 2rem;

  
`;
export const AddNewBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  gap: 5px;
  color: #2555EF;
`;


export const ContactField = styled.div`
  padding: 0 2rem;
`